import React from 'react';
import { Card, CardContent } from './ui/card';
import { whyItWorks } from '../data/mock';

const WhyItWorks = () => {
  return (
    <section 
      id="why-it-works" 
      className="py-12 bg-gradient-to-b from-white via-green-50/20 to-white relative overflow-hidden"
      aria-labelledby="why-heading"
    >
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-green-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" aria-hidden="true" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            id="why-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
          >
            Why These Events <span className="text-green-800">Work</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our curated IWD experiences go beyond celebration to create 
            meaningful, lasting change in workplace culture.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {whyItWorks.map((item) => {
            return (
              <Card 
                key={item.id}
                className="group bg-white border-2 border-gray-200 hover:border-green-600 hover:shadow-xl transition-all duration-300 rounded-2xl overflow-hidden"
              >
                <CardContent className="p-6">
                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom Highlight */}
        <div className="mt-16 bg-green-800 rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-white/10 rounded-full blur-2xl translate-x-1/2 translate-y-1/2" />
          
          <h3 className="text-2xl md:text-3xl font-bold mb-4 relative">
            More Than Just Events
          </h3>
          <p className="text-green-100 text-lg max-w-2xl mx-auto relative">
            Our sessions are designed to create space for meaningful conversations 
            about inclusion, safety, equal opportunity, and the systems shaping 
            women's experiences at work.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyItWorks;
